import moment from "moment-timezone";
import { FORMATS } from "../core/formats";
/**
 * Weekly slots used for table booking timeline (service hours override location hours).
 */
export function getTableBookingSlotsForWeekday(r, weekday) {
    const custom = r.settings.services?.table_booking?.hours;
    const useServiceHours = custom && Array.isArray(custom) && custom.length > 0;
    return useServiceHours
        ? custom.filter((s) => s.day === weekday)
        : (r.location.opening_hours || []).filter((s) => s.day === weekday);
}
/**
 * Absolute [start,end) ms intervals for `day` where the venue accepts bookings (from slots).
 */
export function getOpenWindowIntervalsMsForDay(day, tz, slots) {
    const dateStr = day.clone().tz(tz).format(FORMATS.moment.date);
    const out = [];
    for (const slot of slots) {
        if (slot.h24) {
            const start = moment.tz(dateStr, FORMATS.moment.date, tz).startOf("day").valueOf();
            const end = moment.tz(dateStr, FORMATS.moment.date, tz).endOf("day").valueOf();
            return [{ start, end }];
        }
        const open = moment.tz(`${dateStr} ${slot.open}`, FORMATS.moment.datetime, tz);
        let close = moment.tz(`${dateStr} ${slot.close}`, FORMATS.moment.datetime, tz);
        if (close.isSameOrBefore(open)) {
            close = close.clone().add(1, "day");
        }
        out.push({ start: open.valueOf(), end: close.valueOf() });
    }
    return out;
}
/** Entire booking window must fall inside one open interval (handles split shifts / gaps). */
export function isBookingIntervalWithinOpenHours(windows, startMs, endMs) {
    if (!windows.length)
        return false;
    return windows.some((w) => startMs >= w.start && endMs <= w.end);
}
//# sourceMappingURL=index.js.map